package com.essntl.features.itinerary.ui.itinerary_overview.components

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.platform.LocalUriHandler
import androidx.compose.ui.unit.dp
import com.essntl.features.itinerary.domain.model.ItineraryModel
import com.essntl.features.itinerary.domain.model.shareLink
import com.essntl.uikit.components.iconbutton.outline.EsSmallOutlineIconButton
import com.essntl.uikit.components.iconbutton.primary.EsSmallPrimaryIconButton
import com.essntl.uikit.components.icons.EsIcons
import com.essntl.uikit.components.tooltip.EsTooltip
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme

@Composable
fun ItineraryActionButtonsRow(
    itinerary: ItineraryModel,
    isLoading: Boolean,
    isFailure: Boolean,
    onEditItinerary: (ItineraryModel) -> Unit,
) {
    Row(
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(1.5f.spacing),
        modifier = Modifier
            .fillMaxWidth()
            .clip(
                RoundedCornerShape(
                    bottomStart = 24.dp,
                    bottomEnd = 24.dp,
                ),
            )
            .background(MaterialTheme.esColorScheme.bgSecondary)
            .padding(
                top = 1.5f.spacing,
                bottom = 2.5f.spacing,
            )
            .padding(
                horizontal = 2.5f.spacing,
            ),
    ) {
        if (!isLoading && !isFailure) {
            val uriHandler = LocalUriHandler.current
            EsTooltip(
                text = "Open in web browser",
            ) {
                EsSmallOutlineIconButton(
                    onClick = {
                        itinerary.shareLink?.let { link ->
                            uriHandler.openUri(
                                uri = link,
                            )
                        }
                    },
                    iconRes = EsIcons.Browse,
                )
            }

            EsTooltip(
                text = "Edit",
            ) {
                EsSmallPrimaryIconButton(
                    onClick = {
                        onEditItinerary(itinerary)
                    },
                    iconRes = EsIcons.Edit,
                    enabled = !isLoading,
                )
            }
        }
    }
}